<template>
  <div class='home-my-date'>
    <el-button @click="$router.push({path: '/main/test/list', query: { type: show }})"
               class="test">test</el-button>
    <div>
      <div v-if="show === 'relatives'">
        <!-- <el-row :gutter="24">
          <el-col :span="5">
            <birth-time role="爷爷"
                        birthday="1967-02-29"
                        color="rgb(255,69,0)"
                        pColor="#ffffff"></birth-time>
          </el-col> -->
        <!-- 1967-11-29 -->
        <!-- <el-col :span="5">
            <birth-time role="奶奶"
                        birthday="1966-02-29"
                        color="rgb(255,69,0)"
                        pColor="#ffffff"></birth-time>
          </el-col>
        </el-row> -->
        <!-- <el-divider></el-divider> -->
        <el-row>
          <el-col :span="5">
            <birth-time role="爸爸"
                        birthday="1990-08-30"
                        color="rgb(255,69,0)"
                        pColor="#ffffff"></birth-time>
          </el-col>
          <el-col :span="5">
            <birth-time role="妈妈"
                        birthday="1990-07-13"
                        color="rgb(255,69,0)"
                        pColor="#ffffff"></birth-time>
          </el-col>
          <el-col :span="5">
            <birth-time role="糖豆"
                        birthday="2021-02-23"
                        color=""
                        pColor="#333333"></birth-time>
          </el-col>
        </el-row>
      </div>
      <div v-if="show === 'friends'">
        <p>在俄罗斯象征友谊的颜色是蓝色</p>
        <el-row :gutter="20">
          <el-col :span="5">
            <!-- role="关孟辉" -->
            <birth-time role=""
                        birthday="1994-04-17"
                        color="blue"
                        pColor="#ffffff"></birth-time>
          </el-col>
          <el-col :span="5">
            <!-- role="毛呢" -->
            <birth-time role=""
                        birthday="1997-06-02"
                        color="blue"
                        pColor="#ffffff"></birth-time>
          </el-col>
        </el-row>
        <el-divider></el-divider>
      </div>
      <div v-if="show === 'other'">
        <el-row :gutter="20">
          <el-col>
            <birth-time role="123"
                        birthday=""
                        color=""
                        pColor=""></birth-time>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import BirthTime from "@/components/birthTime.vue";
export default {
  name: "Home",
  data() {
    return {
      show: "",
    };
  },
  mounted() {
    this.show = this.getQueryStringByName("type") || "other";
  },
  components: { BirthTime },
  methods: {
    //获取QueryString的数组
    getQueryString() {
      let result = window.location.search.match(
        new RegExp("[?&][^?&]+=[^?&]+", "g")
      );
      if (result == null) {
        return "";
      }
      for (let i = 0; i < result.length; i++) {
        result[i] = result[i].substring(1);
      }
      return result;
    },
    //根据 QueryString 参数名称获取值
    getQueryStringByName(name) {
      let search =
        window.location.search.substr(1) || window.location.hash.split("?")[1];
      if (!search) return "";
      let result = search.match(new RegExp("(^|&)" + name + "=([^&]+)", "i"));
      if (result == null || result.length < 1) {
        return "";
      }
      return result[2];
    },
    getQueryStringByName2(name) {
      let result = window.location.search.match(
        new RegExp("[?&]" + name + "=([^&]+)", "i")
      );
      if (result == null || result.length < 1) {
        return "";
      }
      return result[1];
    },
  },
};
</script>
<style lang="scss" scoped>
.home-my-date {
  margin-left: 30px !important;
  .el-col-5 {
    width: 248px !important;
    height: auto;
    margin-left: 20px;
  }
}
.test {
  margin-top: 20px !important;
}
</style>
